module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/ja-card-drag.df7fe1f3d63d6fc5835d.gif";